import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import logo from "@/assets/logo.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/app/usercontext";


export function Topbar() {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    const user = useUser();

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    const handleNavigateHome = (e: React.MouseEvent) => {
        e.preventDefault();
        navigate("/week-plan");
    };


    return (
        <Navbar bg="light" expand="lg" expanded={expanded} onToggle={setExpanded} className="shadow-sm mb-4">
            <Container>
                <Navbar.Brand href="#" onClick={handleNavigateHome} style={{ cursor: "pointer" }}>
                    <img
                        src={logo}
                        alt="HippoTrack Logo"
                        width="40"
                        height="40"
                        className="logo-image me-2"
                    />
                    HippoTrack
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="hippotrack-navbar" />
                <Navbar.Collapse id="hippotrack-navbar">
                    <Nav className="me-auto">
                        <Nav className="me-auto">
                            <Nav.Link href="/week-plan">Wochenplan</Nav.Link>
                            <Nav.Link href="/sessions">Sitzungen</Nav.Link>
                            {user?.role === "ADMIN" && (
                                <NavDropdown title="Admin" id="admin-nav-dropdown">
                                    <NavDropdown.Item href="/admin/reports">Berichte</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/admin/clients">Klienten</NavDropdown.Item>
                                    <NavDropdown.Item href="/admin/therapists">Fachkräfte</NavDropdown.Item>
                                    <NavDropdown.Item href="/admin/helpers">Helfer</NavDropdown.Item>
                                    <NavDropdown.Item href="/admin/horses">Pferde</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/admin/users">Benutzer</NavDropdown.Item>
                                </NavDropdown>
                            )}
                        </Nav>
                    </Nav>
                    {user && (
                        <Nav>
                            <NavDropdown title={user.name} id="user-nav-dropdown" align="end">
                                <NavDropdown.ItemText className="text-muted" style={{ fontSize: "0.85em" }}>
                                    {user.username} &middot; {user.role}
                                </NavDropdown.ItemText>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={handleLogout}>Abmelden</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}